import { useEffect } from 'react';
import { trackPageView } from 'base/utils/tracker';
import { ReferralInto } from 'mod/referral/ReferralInto';
import { ReferralBenefits } from 'mod/referral/ReferralBenefits';
import { ReferralProcess } from 'mod/referral/ReferralProcess';
import { ReferralFAQs } from 'mod/referral/ReferralFAQs';
import { ReferralInvite } from 'mod/referral/ReferralInvite';
import styles from '@app/referral/index.module.less';
import cn from 'classnames';
import { useStoreState } from 'base/store';
import Custom404 from '@base/Custom404';
import { EggHunt } from '@pro/common/EggHunt';

const Page: Globals.NextPage = () => {
    const { referralConfig } = useStoreState('persistStore')

    useEffect(() => {
        trackPageView()
    }, []);

    return referralConfig.showReferralButton ? (
        <div className={styles.referral}>
            <ReferralInto
                className={cn(styles.section, styles.info)}
                image={{
                    src: 'asset/width-1800/picture/9c25104c30fd57a6560767d3aa0d1707.png',
                    width: 900,
                    height: 500,
                    fixed: true
                }}
            />
            <ReferralBenefits className={cn(styles.section, styles.benefits)}/>
            <ReferralProcess className={cn(styles.section, styles.process)}/>
            <ReferralFAQs className={cn(styles.section, styles.faqs)}/>
            <ReferralInvite className={cn(styles.section, styles.invite)}/>

            <EggHunt/>
        </div>
    ) : <Custom404/>
};

Page.pageConf = {
    pageCode: 'referral',
};

export default Page;
